export default __webpack_public_path__ + "slices/main/assets/public/media/logos/cheddar.93abaf84dabeaebec3d574f4fef03b0c.png";